module.exports = __webpack_public_path__ + "static/eindruecke2-1e03eaf2ec7cdedca20642ffcc9790d4.jpg";